const makeAPICall = async (
  { method = "POST", payload = null },
  ...customConfigs
) => {
  const headers = {
    "Content-type": "application/json",
  };

  const configs = {
    method,
    headers,
    ...customConfigs,
  };

  if (payload) configs.body = JSON.stringify(payload);

  return window
    .fetch("https://api.paystack.co/transaction/initialize", configs)
    .then((response) => response.json())
    .catch((err) => err);
};

export default makeAPICall;
